import { ApiService } from "./ApiService";
import IDownloadValidateApiService from "./IDownloadValidateApiService";
import ValidationResponse from "../models/DownloadValidationResponseModel";

export default class DownloadValidateApiService extends ApiService
    implements IDownloadValidateApiService {
    constructor(baseUrl: string, language?: string) {
        super(baseUrl, language);
    }

    public validateDownloadHash(
        hash: string,
        downloadId?: string,
        fileId?: string,
        logId?: string
    ): Promise<ValidationResponse> {
        const requestUrl = "/downloads/check";
        let params:
            | { hash: string; downloadid: string }
            | { hash: string; fileid: string; logid: string };
        if (!!downloadId?.length) {
            // use downloadId
            params = { hash, downloadid: downloadId };
        } else {
            // use fileId and logId
            params = { hash, fileid: fileId, logid: logId };
        }
        return this.get<ValidationResponse>(requestUrl, params);
    }
}
